const signaturePads = {};

document.querySelectorAll('canvas.signature-pad').forEach((canvas, index) => {
  const id = canvas.id.split('-').pop(); // gets the number (e.g., "1" from "signature-pad-1")
  signaturePads[id] = new SignaturePad(canvas);
});

function clearSignature(id) {
  if (signaturePads[id]) {
    signaturePads[id].clear();
  }
}

document.querySelectorAll('.toggle-signature').forEach((button) => {
  button.addEventListener('click', function () {
    const wrapper = button.nextElementSibling;

    if (wrapper) {
      wrapper.style.display = wrapper.style.display === 'block' ? 'none' : 'block';
    }
  });
});

document.getElementById('submit').addEventListener('click', function () {
  const form = document.querySelector('#wholesale-registration');

  // 1. Add signature data to corresponding hidden inputs FIRST
  Object.entries(signaturePads).forEach(([id, pad]) => {
    const input = document.getElementById(`signature-data-${id}`);
    if (input && !pad.isEmpty()) {
      input.value = pad.toDataURL();
    }
  });

  // 2. Now validate required fields
  const requiredFields = form.querySelectorAll('[required]');
  let valid = true;

  // Reset any previous highlights
  requiredFields.forEach((field) => {
    field.classList.remove('field__error', 'field--error');
    if (field.parentElement) {
      field.parentElement.classList.remove('field__error', 'field--error');
    }
  });

  // Validate required fields *after* signatures have been populated
  requiredFields.forEach((field) => {
    if (!field.value || !field.value.toString().trim()) {
      if (field.parentElement) {
        field.parentElement.classList.add('field__error');
      } else {
        field.classList.add('field__error');
      }
      valid = false;
    }
  });

  if (!valid) {
    alert('Please fill in all required fields.');
    return;
  }

  // 3. Collect data
  const formData = new FormData(form);
  const payload = {};

  for (const [key, value] of formData.entries()) {
    payload[key] = value;
  }

  // 5. Submit to endpoint (currently commented out)
  // fetch('http://localhost:3006/company/registration', {
  fetch(`${window.enhanceify.appUrl}/company/registration`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      // alert('Form submitted successfully!');
      console.log(data);
      if (data.status === 'success') {
        // if (data.message === 'Form received and email sent successfully.') {
        if (document.querySelector('.registration-steps')) {
          document.querySelector('.registration-steps .step:nth-child(1)').classList.remove('active');
          document.querySelector('.registration-steps .step:nth-child(1)').classList.add('success');
          document.querySelector('.registration-steps .step:nth-child(2)').classList.add('active');
        }

        document.querySelector('.wholesale-form-container').style.display = 'none';
        document.querySelector('.wholesale-form-success').style.display = 'block';
      }
      // form.reset();
      // Object.values(signaturePads).forEach((pad) => pad.clear());
    })
    .catch((err) => {
      alert('Submission failed. Please try again.');
      console.error(err);
    });
});
